import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityCourbevoiePage() {
  const data = citiesData.find((c) => c.slug === "courbevoie")!;
  return <CityPage data={data} />;
}
